// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const OrderHistory: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M17 0c9.39 0 17 7.61 17 17s-7.61 17-17 17c-5.565 0-10.5-2.67-13.6-6.8a1.062 1.062 0 1 1 1.699-1.275c2.717 3.612 7.033 5.95 11.901 5.95 8.214 0 14.875-6.66 14.875-14.875 0-8.214-6.66-14.875-14.875-14.875-5.93 0-11.056 3.473-13.444 8.5h6.006c.585 0 1.063.478 1.063 1.063 0 .584-.478 1.062-1.063 1.062h-8.5A1.064 1.064 0 0 1 0 11.687v-8.5a1.062 1.062 0 1 1 2.125 0v5.519C5.025 3.539 10.598 0 17 0Zm0 8.5c.584 0 1.063.478 1.063 1.063v6.999l5 5c.418.412.418 1.09 0 1.5a1.054 1.054 0 0 1-1.5 0L16.25 17.75c-.2-.199-.372-.471-.372-.75V9.562c0-.584.538-1.062 1.062-1.062H17Z"
            />
        </svg>
    );
};

export default React.memo(OrderHistory);
